module.exports = __webpack_public_path__ + "img/inRecognition.3beb8c42.png";